// extracted by mini-css-extract-plugin
module.exports = {"header":"GameHeader_header__LGFPT","title":"GameHeader_title__mvC7d","info":"GameHeader_info__2Uq7i","leave":"GameHeader_leave__1Uis5"};